import React from 'react';
import { useSelector } from 'react-redux';

import { RootState } from 'store';

import ApplicationOverlayContent from 'components/ApplicationLayout/ApplicationOverlayContent';
import BottomSheet from 'components/BottomSheet';
import HotelsSearch from 'components/HotelsSearch';
import { Desktop, Mobile } from 'components/Responsive';
import { GetAllBillingCompanyResponse } from 'models/billingCompany';
import { TravelArrangerUsersAllowed } from 'services/userService';

import { Container } from './styles';

type Props = {
  allowedTravelers: TravelArrangerUsersAllowed[];
  isLoadingAllowedTravelers: boolean;
  show: boolean;
  onClose: () => void;
  branchCompanies?: GetAllBillingCompanyResponse[];
  isLoadingBranchCompanies: boolean;
};

const HotelsSearchEdit = ({
  allowedTravelers,
  isLoadingAllowedTravelers,
  show,
  onClose,
  branchCompanies,
  isLoadingBranchCompanies,
}: Props) => {
  const { travelers, destinationPoint, checkInDate, checkOutDate, branchCompany } = useSelector(
    (state: RootState) => state.hotels,
  );

  const search = () => (
    <HotelsSearch
      defaultTravelers={travelers}
      defaultDestinationPoint={destinationPoint}
      defaultCheckInDate={checkInDate}
      defaultCheckOutDate={checkOutDate}
      allowedTravelers={allowedTravelers}
      isLoadingAllowedTravelers={isLoadingAllowedTravelers}
      isHome={false}
      onClose={onClose}
      branchCompanies={branchCompanies}
      isLoadingBranchCompanies={isLoadingBranchCompanies}
      defaultBranchCompany={branchCompany}
    />
  );

  return (
    <>
      <Mobile>
        <BottomSheet show={show} onClose={onClose} noHeader zIndex={2}>
          {search()}
        </BottomSheet>
      </Mobile>
      <Desktop>
        <ApplicationOverlayContent show={show} onClose={onClose}>
          <Container>{search()}</Container>
        </ApplicationOverlayContent>
      </Desktop>
    </>
  );
};
export default HotelsSearchEdit;
